import { useContext, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import TabGroup from "../../../App/Components/TabGroup/TabGroup";
import { ITabGroupConfig } from "../../../App/Typings/TabPanel";
import { CampaignResponses } from "../CampaignResponses/CampaignResponses";
import { Notes } from "../Notes/Notes";
import ProfileRatings from "../Ratings/ProfileRatings";
import CandidateUpdateHistory from "../UpdateHistory/CandidateUpdateHistory";
import { CandidateCurrentTabContext } from "./State/CandidateTabsState";
import { AppFeatureLookup } from "../../../App/Constants/AbacConstants";
import { useFeaturePermission } from "../../../App/State/Hooks/abacHooks";

export function CandidateTabs() {
  const [search] = useSearchParams();
  const { currentTab, handleTabChange, hasCampaignResponses } = useContext(CandidateCurrentTabContext);
  const tabs = useCandidateTabs();

  const tabGroupConfig: ITabGroupConfig = {
    groupLabel: "Candidate Actions",
    id: "candidate-tabs",
    currentTabState: currentTab,
    changeTabState: handleTabChange,
    tabs,
  };

  if (!hasCampaignResponses) {
    tabGroupConfig.tabs = tabGroupConfig.tabs.filter((tab) => tab.label !== "Form Responses");
    const currentTab = search.get("tab");
    if (currentTab === "Form Responses" || currentTab === "Form+Responses") {
      handleTabChange("Notes");
    }
  }

  return <TabGroup config={tabGroupConfig} />;
}

const useCandidateTabs = () => {
  const historyAccess = useFeaturePermission(AppFeatureLookup.ProfileViewCandidateUpdateHistory);
  const campaignResponsesAccess = useFeaturePermission(
    AppFeatureLookup.ProfileViewCandidateCampaignResponses
  );

  const permissionLookup: Record<string, boolean> = {
    "Update History": historyAccess,
    "Form Responses": campaignResponsesAccess,
  };

  return useMemo(
    () => Object.values(defaultTabPanels).filter((accordion) => permissionLookup[accordion.label] ?? true),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [historyAccess, campaignResponsesAccess]
  );
};

const defaultTabPanels = {
  notesTabPanel: {
    label: "Notes",
    TabComponent: Notes,
  },
  ratingsTabPanel: {
    label: "Ratings",
    TabComponent: ProfileRatings,
  },
  updateHistoryTabPanel: {
    label: "Update History",
    TabComponent: CandidateUpdateHistory,
  },
  campaignResponsesTabPanel: {
    label: "Form Responses",
    TabComponent: CampaignResponses,
  },
};
